import { render } from "./WordCloud.vue?vue&type=template&id=2ffd2b65"
import script from "./WordCloud.vue?vue&type=script&lang=js"
export * from "./WordCloud.vue?vue&type=script&lang=js"

import "./WordCloud.vue?vue&type=style&index=0&id=2ffd2b65&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__